module.exports = {
      id: "inlombardia-logo-usage",
      viewBox: "0 0 512 126",
      url: __webpack_public_path__ + "images/sprites/brand.svg#inlombardia-logo-usage",
      toString: function () {
        return this.url;
      }
    }